import { SIGNALR_EVENT_NAMES } from '../constants';
import { notificationUpdated } from '../eventHandlers/default';

export const setupDefaultEventListeners = (connection) => {
  connection.on(SIGNALR_EVENT_NAMES.DEFAULT.notificationUpdated, notificationUpdated);
};
